
import { EventType, StatisticsService } from 'src/app/services/statistics.service';
import { PublicViewTracker, ViewTracker } from './viewtracker';
import { lastValueFrom } from 'rxjs';

export class PageViewTracker extends ViewTracker implements PublicPageViewTracker {
    constructor(private stats: StatisticsService) {
        super('PageView');
    }

    // protected async create(body: any): Promise<string> {
    //     const response: { success: boolean, data: any } = await lastValueFrom(this.stats.InitPageView(body));
    //     return response.data.page_view_id.id_page_view;
    // }

    // protected ping(viewId: string): void {
    //     lastValueFrom(this.stats.PingPageView(viewId)).catch();
    // }

    // protected async closeApi(viewId: string): Promise<void> {
    //     await lastValueFrom(this.stats.ExitPageView(viewId));
    // }

    // protected async startApi(viewId: string): Promise<void> {
    //     await lastValueFrom(this.stats.StartPageView(viewId));
    // }

    // protected async finishApi(viewId: string): Promise<void> {
    //     await lastValueFrom(this.stats.FinishPageView(viewId));
    // }

    
    protected async create(body: any): Promise<any> {
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.PageViewNew,
      properties: {
        pageViewUuid: this.viewId,
        siteVisitUuid: this.stats.siteVisitUuid,
        slug: body.slug,
        fromSlug: body.fromSlug ?? null,
      }
    }));
  }

  protected ping(): void {
    lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.PageViewPing,
      properties: { pageViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
    })).catch();
  }

  protected async startApi(): Promise<void> {
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.PageViewPing,
      properties: { pageViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
    }));
  }

  protected async finishApi(): Promise<void> {
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.PageViewFinish,
      properties: { pageViewUuid: this.viewId, siteVisitUuid: this.stats.siteVisitUuid }
    }));
  }

  protected async closeApi(): Promise<void> {
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: EventType.PageViewExit,
      properties: {
        pageViewUuid: this.viewId,
        siteVisitUuid: this.stats.siteVisitUuid,
        toSlug: 'eventos',
      }
    }));
  }
}

export interface PublicPageViewTracker extends PublicViewTracker { }